export const API_URL = (() => {
    switch (process.env.REACT_APP_HMZ_ENV) {
        case 'prod':
            return 'https://api.myharmonize.com';
        case 'dev':
            return 'https://api.harmonize.live';
        case 'local':
        default:
            return 'http://localhost';
    }
})();
export const TRACKER = (() => {
    switch (process.env.REACT_APP_HMZ_ENV) {
        case 'prod':
            return 'UA-139588208-1';
        case 'dev':
        case 'local':
        default:
            return null;
    }
})();
export const SITE_URL = (() => {
    return `${window.location.protocol}//${window.location.host}`;
})();
export const GOOGLE_MAPS_API_KEY = (() => {
    return process.env.REACT_APP_HMZ_MAPS_API_KEY;
})();
const libraries = ['places'];
export const googleMapsProps = {
    id: 'google-map-script',
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
    libraries,
};
export const AUTH_COOKIE_NAME = 'harmonizeLoginSession';
export const API_ENDPOINTS = {
    account: () => `${API_URL}/accounts`,
    accountDetails: () => `${API_URL}/account`,
    accountGoogleAnalyticsIDs: () => `${API_URL}/account/analytics`,
    accountDatabases: (accountName) => `${API_URL}/accounts/${accountName}/databases`,
    accountSearch: (searchTerm, max = 0, clientOnly = false) => {
        // TODO more acrobatics to handle the wildcard...
        searchTerm = searchTerm === '*' ? searchTerm : `${searchTerm}*`;
        const maxHits = max ? `&maxHits=${max}` : '';
        return `${API_URL}/searches/~accounts?organization=${searchTerm}${clientOnly ? '&roles=client' : ''
            }${maxHits}`;
    },
    activateAccount: () => `${API_URL}/tokens/activate`,
    attachments: (name, organization) =>
        `${API_URL}/attachments${organization ? `/${organization}${name ? `/${name}` : ''}` : ''}`,
    avatars: () => `${API_URL}/avatars`,
    databases: (databaseName, accountName) =>
        `${API_URL}/databases${accountName ? '/' + accountName : ''}${databaseName ? '/' + databaseName : ''
        }`,
    analytics: (databaseName) =>
        `${API_URL}/databases/analytics${databaseName ? '/' + databaseName : ''}`,
    loginSearch: (searchTerm) => `${API_URL}/searches/~logins?userName=${searchTerm}*`,
    logins: () => `${API_URL}/logins`,
    organization: () => `${API_URL}/account/organization`,
    organizationInbox: () => `${API_URL}/mails/inbox`,
    organizationOutbox: () => `${API_URL}/mails/outbox`,
    geoHash: () => `${API_URL}/geo/hash`,
    pages: (pageName) => `${API_URL}/pages${pageName ? '/' + pageName : ''}`,
    approvePage: (pageName) => `${API_URL}/pages/${pageName}/approve`,
    unapprovePage: (pageName) => `${API_URL}/pages/${pageName}/withdraw`,
    pendingPages: () => `${API_URL}/pages/unapproved`,
    approvedPages: () => `${API_URL}/pages/approved`,
    partners: () => `${API_URL}/partners`,
    pendingPartnersCount: () => `${API_URL}/partners/pending/count`,
    passwordReset: () => `${API_URL}/tokens/password.reset`,
    passwordResetRequest: () => `${API_URL}/tokens/query.password.reset`,
    personalInbox: () => `${API_URL}/mails/login`,
    readMessage: (id) => `${API_URL}/mails/${id}`,
    sendMessage: () => `${API_URL}/mails`,
    getMessageThread: (id) => `${API_URL}/mails/threads/${id}`,
    getAccountsForDatabase: (name) => `${API_URL}/mails/addresses/${name}`,
    deleteMessage: (id) => `${API_URL}/mails/${id}`,
    search: (databaseName) => `${API_URL}/searches/${databaseName}`,
    sessions: (sessionName) => `${API_URL}/sessions/${sessionName}`,
    updateOrganization: () => `${API_URL}/account/organization`,
    updateOwner: () => `${API_URL}/account/owner`,
    public: {
        organization: (orgName) => `${API_URL}/public/accounts/${orgName}/organization`,
        owner: (orgName) => `${API_URL}/accounts/${orgName}/owner`,
    },
};
export const CLIENT_PATH = '/client';
export const PUBLIC_PATH = '/public';
export const EMBED_PATH = '/embed';
export const EMBED_PAGE_PATH = (name, account) =>
    `${EMBED_PATH}/pages${name ? `/${name}` : ''}${account ? `/${account}` : ''}`;
export const PUBLIC_PAGE_PATH = (name, account) =>
    `${PUBLIC_PATH}/pages${name ? `/${name}` : ''}${account ? `/${account}` : ''}`;
export const PAGE_PATH = (name, account) =>
    window.location.pathname.includes(EMBED_PATH)
        ? EMBED_PAGE_PATH(name, account)
        : PUBLIC_PAGE_PATH(name, account);
export const EMBED_SEARCH_PATH = (databaseName, accountName) =>
    `${EMBED_PATH}/${databaseName}/${accountName}/search`;
export const PUBLIC_SEARCH_PATH = (databaseName, accountName, pageId) =>
    `${PUBLIC_PATH}/${databaseName}/${accountName}/search${pageId ? `?pageId=${pageId}` : ''}`;
export const SEARCH_PATH = (databaseName, accountName) =>
    window.location.pathname.includes(EMBED_PATH)
        ? EMBED_SEARCH_PATH(databaseName, accountName)
        : PUBLIC_SEARCH_PATH(databaseName, accountName);

export const LOGIN_PATH = `${CLIENT_PATH}/login`;
export const PAGES_PATH = `${CLIENT_PATH}/dashboard/info`;
export const DASHBOARD_PATH = `${CLIENT_PATH}/dashboard`;
export const MESSAGES_PATH = `${CLIENT_PATH}/dashboard/messages`;
export const MESSAGES_DETAIL_PATH = `${CLIENT_PATH}/dashboard/messages/:id`;
export const PARTNERS_PATH = `${CLIENT_PATH}/dashboard/partners`;
export const DATABASE_CREATE_PATH = `${CLIENT_PATH}/create/database`;
export const PROFILE_EDIT = `${CLIENT_PATH}/profile`;
export const HELP_PATH = `${CLIENT_PATH}/dashboard/help`;
export const CLIENT_CONTACT_PATH = `${CLIENT_PATH}/dashboard/contact`;

export const DATABASE_UPDATE_PATH = (databaseName) =>
    `${CLIENT_PATH}/update/database/${databaseName}`;
export const PAGE_CREATE_PATH = (databaseName) => `${CLIENT_PATH}/create/info/${databaseName}`;
export const PAGE_UPDATE_PATH = (pageName) => `${CLIENT_PATH}/update/info/${pageName}`;
export const ABOUT_PATH = `${PUBLIC_PATH}/about`;
export const TERMS_PATH = `${PUBLIC_PATH}/terms`;
export const PRIVACY_PATH = `${PUBLIC_PATH}/privacy`;
export const CONTACT_PATH = `${PUBLIC_PATH}/contact`;

export const PARTNER_PAGE_SIZE = 10;



// WEBPACK FOOTER //
// ./src/constants.js